import App from './App.vue'
import router from './router'
import { loadLang } from '/@/lang'
import { registerIcons } from '/@/utils/common'
import ElementPlus from 'element-plus'
import mitt from 'mitt'
import pinia from '/@/stores/index'
import { directives } from '/@/utils/directives'
import '/@/styles/tailwind.css'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import '/@/styles/index.scss'
import { errorHandler } from '/@/utils/errorUtils'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

// modules import mark, Please do not remove.

async function start () {
  const app = createApp(App)
  app.use(pinia)

  // 全局语言包加载
  const i18n = await loadLang(app)

  app.use(router)
  app.use(ElementPlus, { i18n: i18n.global.t } as any)

  // 全局注册
  directives(app) // 指令
  registerIcons(app) // icons

  const { MODE, VITE_SENTRY_DSN } = import.meta.env
  if ([ 'development', 'staging' ].includes(MODE) && VITE_SENTRY_DSN) {
    Sentry.init({
      app,
      dsn: VITE_SENTRY_DSN,
      // 受限服务器 Sentry 版本，BrowserTracing 无法兼容提示 403 错误
      integrations: [
        // new Integrations.BrowserTracing({
        //   routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        //   // tracingOrigins 默认值: ['localhost', /^\//]
        //   // tracingOrigins: [ 'localhost', /^http:\/\/192.168.16.90/ ]
        // })
      ],
      tracesSampleRate: 1.0,
      logErrors: true,
      // debug: true,
      ignoreErrors: [
        'canceled',
        'ResizeObserver loop completed with undelivered notifications.'
      ],
      // beforeSend: (event) => {
      //   console.log('debug:🚀 ~ Line: 48 -> beforeSend, hint', event)
      //   return event
      // }
    })
  }

  app.mount('#app')

  // modules start mark, Please do not remove.

  app.config.globalProperties.$sentry = Sentry
  app.config.globalProperties.eventBus = mitt()
  app.config.errorHandler = errorHandler
}
start()
